export default __webpack_public_path__ + "static/media/tmdb_logo.f15b6632.svg";